import { createSelector } from '@reduxjs/toolkit';

import {
  getFromImmutableStateCompatible,
  getImmutableCompatible,
} from 'src/utils/immutableUtils';
import { getExploreFiltersForQueryString } from 'src/utils/filtersUtils';
import { getFiltersFromUrl } from 'src/routes/SeoApp/utils';
import { getFiltersName } from 'src/routes/SearchPage/controllers/getFilterName';

export const getFilters = (state) => getImmutableCompatible(state, 'filters');
export const getPlainFilters = getFromImmutableStateCompatible(getFilters);

export const getAllFiltersDisabled = createSelector(
  getPlainFilters,
  (filters) => filters.all_disabled,
);

export const getFilter = createSelector(
  [getPlainFilters, (_, filterName: string) => filterName],
  (filters, filterName) => filters[filterName],
);

export const getMinPrice = createSelector(
  (state) => getFilter(state, 'prices'),
  (prices) => (prices ? prices.min : null),
);

/**
 * Используется для формирования query-параметров при переходе
 * на страницу отеля
 */
export const getOfferFilters = createSelector(getPlainFilters, (filters) =>
  getExploreFiltersForQueryString(filters),
);

export const activeFiltersSelector = createSelector(
  getPlainFilters,
  (filtersData) => {
    // собираем активные фильтры из url
    const activeFiltersName = Object.keys(getFiltersFromUrl());

    // находим данные активных фильтров
    const activeFilters = Object.entries(filtersData).filter(([key]) => {
      if (key === 'prices') {
        return ['filter_price_min', 'filter_price_max'].some(
          (name) => activeFiltersName.indexOf(name) !== -1,
        );
      }
      return activeFiltersName.indexOf(`filter_${key}`) !== -1;
    });

    return getFiltersName(activeFilters);
  },
);
